import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph firstPg">
        At a big-box store in the UK, a customer hesitates in front of a locked case of
        noise-canceling headphones. The gear looks like just what she needs to help calm her nerves
        on her upcoming flight from a nearby regional airport. Unfortunately, the clock is ticking,
        and she doesn’t have time to hunt down an employee to get help. Just as she’s about to turn
        away, an associate approaches her and unlocks the case. The woman heads to the airport,
        headphones in hand, just minutes after entering the store.
      </p>
      <p className="chapter__paragraph">
        And her experience just keeps getting better. The airport feels less crowded than when the
        woman last flew, there are plenty of agents at counters to help her check in, so she doesn’t
        have to wait, and she’s through the security line in record time. The woman’s trip is off to
        a great start—unbeknownst to her, with the help of artificial intelligence working behind
        the scenes.
      </p>
    </section>
  );
}

export default Chapter1;
